/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldRequest } from './FieldRequest';
import {
    FieldRequestFromJSON,
    FieldRequestFromJSONTyped,
    FieldRequestToJSON,
    FieldRequestToJSONTyped,
} from './FieldRequest';

/**
 * 
 * @export
 * @interface UpdateFieldsRequest
 */
export interface UpdateFieldsRequest {
    /**
     * The complete list of fields to set, replacing any existing fields
     * @type {Array<FieldRequest>}
     * @memberof UpdateFieldsRequest
     */
    customFields: Array<FieldRequest>;
}

/**
 * Check if a given object implements the UpdateFieldsRequest interface.
 */
export function instanceOfUpdateFieldsRequest(value: object): value is UpdateFieldsRequest {
    if (!('customFields' in value) || value['customFields'] === undefined) return false;
    return true;
}

export function UpdateFieldsRequestFromJSON(json: any): UpdateFieldsRequest {
    return UpdateFieldsRequestFromJSONTyped(json, false);
}

export function UpdateFieldsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFieldsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customFields': ((json['customFields'] as Array<any>).map(FieldRequestFromJSON)),
    };
}

export function UpdateFieldsRequestToJSON(json: any): UpdateFieldsRequest {
    return UpdateFieldsRequestToJSONTyped(json, false);
}

export function UpdateFieldsRequestToJSONTyped(value?: UpdateFieldsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customFields': ((value['customFields'] as Array<any>).map(FieldRequestToJSON)),
    };
}

